/**
 * @generated SignedSource<<5ba105e1518b804fe9a206a3fcf8df4b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DirectReportsUser$data = {
  readonly id: string;
  readonly internalAttributes: {
    readonly data: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly activeRecurring1on1Event: {
            readonly recurrenceRule: ReadonlyArray<string | null> | null;
            readonly start: string | null;
          } | null;
          readonly email: string;
          readonly fullName: string;
          readonly id: string;
          readonly isGuest: boolean;
        };
      }>;
    } | null;
  } | null;
  readonly " $fragmentType": "DirectReportsUser";
};
export type DirectReportsUser$key = {
  readonly " $data"?: DirectReportsUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectReportsUser">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "internalAttributes",
  "data"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./DirectReportsPaginationQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "DirectReportsUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserInternalAttributes",
      "kind": "LinkedField",
      "name": "internalAttributes",
      "plural": false,
      "selections": [
        {
          "alias": "data",
          "args": [
            {
              "kind": "Literal",
              "name": "includeGuests",
              "value": true
            }
          ],
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "__DirectReports_data_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fullName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "email",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isGuest",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Event",
                      "kind": "LinkedField",
                      "name": "activeRecurring1on1Event",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "start",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "recurrenceRule",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "IndexedPageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "__DirectReports_data_connection(includeGuests:true)"
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "437e264d79032aa1475c1de5fa357e68";

export default node;
